import { useContext, useState } from "react";
import { BEVersion, patchNote } from "../api/FetchAPI";
import { feversion } from "../lib/config/index";
import { AuthContext } from "../components/AuthContextComponent";
import useUserLogin from "./UserLoginhook";
import { FetchErr } from "../lib/helpers/UnhandledError";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const usePatchNote = () => {
  const [beversion, setBEVersion] = useState<string | any>();
  const [releaseDate, setReleaseDate] = useState<string[]>([]);
  const [newFeatures, setNewFeatures] = useState<string[]>([]);
  const [improvements, setImporvements] = useState<string[]>([]);
  const { userInfo } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";

  //Fetch FrontEnd version
  const PatchNote = async () => {
    const response: any = await patchNote();
    setReleaseDate(response.releaseDate);
    setNewFeatures(response.newFeatures);
    setImporvements(response.improvements);
  };

  //Fetch BackEnd version
  const fetchBEVErsion = async () => {
    try {
      const version: any = await BEVersion();
      setBEVersion(version);
    } catch (error: any) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  const frontEndPatchImprovements = [
    "- Implemented file type validation for uploads. Users will now see an “Invalid File Type” prompt if the selected file is not supported.",
  ];

  const frontEndPatchFeatures = [""];

  return {
    feversion,
    frontEndPatchFeatures,
    frontEndPatchImprovements,
    beversion,
    releaseDate,
    newFeatures,
    improvements,
    PatchNote,
    fetchBEVErsion,
  };
};
export default usePatchNote;
